import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../core/core.module';
import { State } from '../../../vista-usuario/vista-usuario.state';
import { EquipamientoProcesamiento } from '../../entity-equipamientos-procesamiento/equipamientos-procesamiento.model';
import { Especie } from '../../entity-especies/especies.model';
import { selectAllEspecies } from '../../entity-especies/especies.selectors';

import { TipoEquipamientoProcesamiento } from '../../entity-tipo-equipamiento-procesamiento/tipos-equipamiento-procesamiento.model';
import { selectAllTiposEquipamientoProcesamiento } from '../../entity-tipo-equipamiento-procesamiento/tipos-equipamiento-procesamiento.selectors';
import {
  ProcesamientoMaquinariaEspecies,
  createEmptyProcesamientoMaquinariaEspecies
} from '../../entity-sitios-procesamiento/sitios-procesamiento.model';
import { map } from 'rxjs/operators';

@Component({
  selector: 'rpe-registro-actividad-sitio-procesamiento-equipamiento-form',
  templateUrl:
    './registro-actividad-sitio-procesamiento-equipamiento-form.component.html',
  styleUrls: [
    './registro-actividad-sitio-procesamiento-equipamiento-form.component.scss'
  ]
})
export class RegistroActividadSitioProcesamientoEquipamientoFormComponent implements OnInit {
  @Input()
  set formInput(
    procesamientoMaquinariaEspecies: ProcesamientoMaquinariaEspecies
  ) {
    if (procesamientoMaquinariaEspecies != null) {
      this._procesamientoMaquinariaEspecies = procesamientoMaquinariaEspecies;
      this.setValues(this._procesamientoMaquinariaEspecies);
    }
  }
  get formInput(): ProcesamientoMaquinariaEspecies {
    return this._procesamientoMaquinariaEspecies;
  }

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<ProcesamientoMaquinariaEspecies>();

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  equipamientoFormGroup = this.fb.group({
    maquinas: this.fb.array([]),
  });

  addOther = false;
  _procesamientoMaquinariaEspecies: ProcesamientoMaquinariaEspecies;

  tiposEquipamientoProcesamiento$: Observable<TipoEquipamientoProcesamiento[]>;

  constructor(private fb: FormBuilder, private store: Store<State>) { }

  ngOnInit(): void {
    this.tiposEquipamientoProcesamiento$ = this.store.select(
      selectAllTiposEquipamientoProcesamiento
    );

    this.emitirEquipamientoProcesamiento();
    this.emitirEquipamientoStatusProcesamiento();

    // emit events
    this.equipamientoFormGroup.valueChanges.subscribe((_) => {
      this.emitirEquipamientoProcesamiento();
    });

    this.equipamientoFormGroup.statusChanges.subscribe((s) => {
      this.emitirEquipamientoStatusProcesamiento();
    });
  }

  emitirEquipamientoProcesamiento() {
    let pme: ProcesamientoMaquinariaEspecies =
      createEmptyProcesamientoMaquinariaEspecies();
    pme.equipamientoProcesamiento =
      this.equipamientoFormGroup.get('maquinas').value;
    this.formValueChanges.emit(pme);
  }

  emitirEquipamientoStatusProcesamiento() {
    let status = this.equipamientoFormGroup.valid ? 'VALID' : 'INVALID';
    this.formStatusChanges.emit(status);
  }

  //maquinas
  maquinas(): FormArray {
    return this.equipamientoFormGroup.get('maquinas') as FormArray;
  }

  nuevoEquipamientoProcesamiento(): FormGroup {
    return this.fb.group({
      id: [, []],
      tipo_equipamiento_procesamiento_id: [, [Validators.required]],
      marca: [, [Validators.required]],
      modelo: [, [Validators.required]],
      n_precinto: [, []],
      gps: [, []],
      tipo_equipamiento_procesamiento_nombre: [, []]
    });
  }

  nuevoEquipamientoProcesamientoParams(
    e: EquipamientoProcesamiento
  ): FormGroup {
    return this.fb.group({
      id: [e.id, []],
      tipo_equipamiento_procesamiento_id: [
        e.tipo_equipamiento_procesamiento_id,
        [Validators.required]
      ],
      marca: [e.marca, [Validators.required]],
      modelo: [e.modelo, [Validators.required]],
      n_precinto: [e.n_precinto, []],
      gps: [e.gps, []],
      tipo_equipamiento_procesamiento_nombre: [
        e.tipo_equipamiento_procesamiento_nombre,
        []
      ]
    });
  }

  agregarMaquina() {
    this.maquinas().push(this.nuevoEquipamientoProcesamiento());
  }

  eliminarMaquina(depIndex: number) {
    this.maquinas().removeAt(depIndex);
  }

  checkErrors(): void {
    this.equipamientoFormGroup.markAllAsTouched();
  }

  setValues(pme: ProcesamientoMaquinariaEspecies) {
    if (pme) {
      // EquipamientoProcesamiento
      if (pme.equipamientoProcesamiento) {
        pme.equipamientoProcesamiento.forEach((e) => {
          const epForm = this.nuevoEquipamientoProcesamientoParams(e);
          this.maquinas().push(epForm, { emitEvent: false });
        });
      } else {
        this.agregarMaquina();
      }
    }
  }
}
